import styled from '@emotion/styled/macro';
import { Variables } from '../base';

export type StatusIndicator = 'complete' | 'inProgress' | 'actionRequired' | 'awaiting' | 'loopDetected';

export const Card = styled.section`
    background: ${Variables.Colors.white};
    padding: 12px 14px;
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
`;

export const Eyebrow = styled.span`
    color: ${Variables.ThemeLight.TextXMild};
    font-size: 14px;
    font-weight: 600;
`;

export const StatusPill = styled.span<{ $indicator: StatusIndicator }>`
    background: ${({ $indicator }) =>
        $indicator === 'complete'
            ? Variables.ThemeLight.SuccessMild1
            : $indicator === 'loopDetected'
              ? Variables.ThemeLight.WarningMild1
              : $indicator === 'actionRequired' || $indicator === 'awaiting'
                ? Variables.ThemeLight.AttentionMild1
                : Variables.ThemeLight.NeutralMild1};
    color: ${Variables.ThemeLight.TextMedium};
    border-radius: 999px;
    padding: 2px 10px;
    font-size: 12px;
    font-weight: 500;
`;

export const Title = styled.h3`
    margin: 0 0 2px 0;
    color: ${Variables.ThemeLight.TextStrong};
    font-size: 30px;
    font-weight: 600;
`;

export const Subtitle = styled.p`
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${Variables.ThemeLight.TextMedium};
    font-size: 16px;
    font-weight: 400;
`;
